package org.hs_soft.runmynesto.pages.home.sub_page.product.mvi

import androidx.compose.runtime.MutableState
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.ProductInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.kitchen_info.ProductAdditions
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum

sealed class ProductEvent{

    data class UpdateSelectedProductSet(
        val setModel: SetModel?
    ):ProductEvent()

    data class SetDeleteFixedProductDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class OnFixedProductItemClick(
        val code:String
    ):ProductEvent()

    data class OnSearchInFixedProducts(
        val searchValue: String,
    ):ProductEvent()

    data class SetAddProductFixDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class SetEditProductFixDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class SetCreateNewProductSetDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class AddProductSets(
        val categoryId:String
    ):ProductEvent()

    data class AddFixedProductSet(
        val productId:String,
        val price:Double?,
        val quantity:Int
    ):ProductEvent()

    data class EditFixedProductSet(
        val productId:String,
        val price:Double?,
        val quantity:Int
    ):ProductEvent()

    data object DeleteFixedProductSet:ProductEvent()

    data object DeleteProductSets:ProductEvent()

    data class OnProductSetItemClick(
        val id:String
    ):ProductEvent()

    data class CreateSpecialPrice(
        val startTime: String,
        val name: String,
        val type: Int,
        val dateFrom: String,
    ):ProductEvent()

    data class SetDeleteProductSetDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class OnSearchInProductSets(
        val searchValue:String
    ):ProductEvent()

    data class GetProductSets(
        val id:String
    ):ProductEvent()

    data class UpdateProductSets(
        val title: String,
        val value: dynamic,
    ):ProductEvent()

    data class OnSearchInPrices(
        val title: String
    ):ProductEvent()

    data object DeleteSpecialPrice:ProductEvent()

    data class UpdateSpecialPrice(
        val title: String,
        val value: dynamic,
    ):ProductEvent()

    data class CreateProductIngredients(
        val name: String,
        val keyword: String,
        val unit: String,
        val number: String
    ):ProductEvent()

    data class SetAddPriceDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data class SetDeletePriceDialogStatus(
        val status: Boolean
    ):ProductEvent()


    data class OnPriceItemClick(
        val id:String
    ):ProductEvent()

    data object GetPriceLevels:ProductEvent()

    data class SetCreateCustomAlergeneDialogStatus(
        val status: Boolean
    ):ProductEvent()

    data object DismissErrorDialog:ProductEvent()

    data class OnSubmitKitchenInfoDialog(
        val id:String,
        val name:String,
        val variants:List<String?>
    ):ProductEvent()

    data object OnAddKitchenItemIconClick:ProductEvent()
    data object OnEditKitchenItemIconClick:ProductEvent()
    data object OnDeleteKitchenItemIconClick:ProductEvent()
    data object OnCancelKitchenItemDialog:ProductEvent()
    data class OnKitchenInfoItemClick(val info: ProductAdditions?):ProductEvent()

    data object OnRefreshKitchenInfoClick:ProductEvent()
    data class OnSearchKitchenInfo(val value:String):ProductEvent()
    data object GetKitchenInfo:ProductEvent()
    data object DismissDeleteKitchenInfoDialogStatus:ProductEvent()
    data class DeleteKitchenInfo(val id:String):ProductEvent()
    data object RefreshProductsCategoryList:ProductEvent()
    data object GetProductsCategoryList:ProductEvent()
    data object GetCheckedIngredients:ProductEvent()

    data class GetCachedBidImg(
        val imageUrl:MutableState<String?>,
        val key:String,
    ):ProductEvent()


    data object GetCompanyProfileId:ProductEvent()

    data class UpdateAllergenContent(
        val content:Boolean,
        val ingredientId:String
    ):ProductEvent()

    data class OnProductItemClick(
        val id:String,
        val switchTheSecondPage:()->Unit={}
    ):ProductEvent()

    data class UpdateProductInfo(
        val title:String,
        val value:dynamic
    ):ProductEvent()

    data class UpdateProductPrice(
        val title: String,
        val value:List<Double?>
    ):ProductEvent()

    data class OnSearchProductInputChange(val value:String):ProductEvent()

    data class UpdateCheckout(
        val dataValue:MutableSet<String>
    ): ProductEvent()

    data object GetCheckoutData: ProductEvent()


    data class UpdateProductProperties(
        val title:String,
        val minOrder:Double?,
        val maxOrder:Double?,
        val timeLeadDays:Double?
    ): ProductEvent()

    data object GetProductSalesGroup:ProductEvent()



    data object GetRestaurantData:ProductEvent()

    data object GetPrinterLocationNames:ProductEvent()


    data object GetIngredients:ProductEvent()


    data class UpdateRestaurantData(
        val title:String,
        val value:dynamic
    ): ProductEvent()


    //Search
    data class OnSearchCheckoutItems(val value:String):ProductEvent()

    data class OnSearchIngredientItems(val value:String):ProductEvent()

    data object OnMainGridTitleSortClick:ProductEvent()

    data object OnMainGridNumberSortClick:ProductEvent()



    //Other
    data class OnTabClick(val selectedTab: ProductInfoHeaderEnum):ProductEvent()

    data object OnChangePageClick: ProductEvent()


    //Image Proccessing

    data class OnChangeAiImageDescription(
        val value:String
    ): ProductEvent()

    data class SetLocalCashBidImg(
        val url:String,
    ):ProductEvent()

    data class OnSelectCashBidImg(
        val url:String?,
        val id:String
    ):ProductEvent()

    data class SetGenerateCashBidAIImgDialogStatus(
        val status:Boolean
    ):ProductEvent()

    data class GenerateProductCashBidImg(
        val description:String
    ):ProductEvent()

    data object OnAddRecordIconClick: ProductEvent()
    data object OnCancelRecordDialogClick: ProductEvent()
    data class OnSubmitAddRecordDialogClick(val windowMode: WindowSizeModeEnum): ProductEvent()
    data class OnChangeRecordNumber(val value:String): ProductEvent()
    data class OnChangeRecordName(val value:String): ProductEvent()


    //Filter
    data class SetFilterProductItemsComponentStatus(val status:Boolean): ProductEvent()

    data object SubmitFilterProductItems: ProductEvent()
    data class SelectProductFilterType(val type: GridItemsFilterEnum):ProductEvent()


    data object OnKitchenInfoTitleClick:ProductEvent()

    data class SetCreateAlergeneComponentStatus(
        val status: Boolean
    ): ProductEvent ()


}